class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    const cartLinkMobile = document.querySelector('#cart-icon-bubble-mb');
    cartLinkMobile.setAttribute('role', 'button');
    cartLinkMobile.setAttribute('aria-haspopup', 'dialog');
    cartLinkMobile.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkMobile);
    });
    cartLinkMobile.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkMobile);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, openDrawer = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    let cartReminder = document.querySelector('#cart-count-reminder');
    this.getSectionsToRender().forEach((section) => {
      if(!cartReminder && section.id === 'cart-count-reminder' || !cartReminder && section.id === 'cart-reminder'){
        return;
      }
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if(section.id === 'cart-count-reminder' || section.id === 'cart-reminder'){
        let closeButton = document.querySelector('.btn-cart-reminder__close');
        if(closeButton){
          closeButton.addEventListener('click', function () {
            document.querySelector('.cart-count-reminder').classList.add('hidden__reminder');
          });
        }
        let itemCount = parseInt(sectionElement.querySelector('.cart-count-reminder__inner').dataset.itemCount);
        if(itemCount === 0 && cartReminder){
          cartReminder.classList.add('hidden');
          cartReminder.classList.remove('active');
        }else if(itemCount > 0 && cartReminder){
          cartReminder.classList.remove('hidden');
        }
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (openDrawer) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble-mb'
      },
      {
        id: 'cart-reminder',
        selector: '#cart-count-reminder',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-mb',
        section: 'cart-icon-bubble-mb',
        selector: '.shopify-section',
      },
      {
        id: 'cart-count-reminder',
        section: 'cart-reminder',
        selector: '#cart-count-reminder',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


window.addEventListener('DOMContentLoaded', function() {
  function getDrawerHeaderHeight() {
    const drawerElement = document.querySelector('#CartDrawer');
    const drawerHeader = drawerElement.querySelector('.drawer__header');
    if (drawerHeader) {
      const drawerHeaderHeight = drawerHeader.offsetHeight;
      drawerElement.style.setProperty('--drawer-header-height', `${drawerHeaderHeight}px`);
    }
  }
  getDrawerHeaderHeight();
  window.addEventListener('resize', function() {
    getDrawerHeaderHeight();
  });
});